import React, { ReactElement } from 'react';
import classes from './Table.module.scss';
import classNames from 'classnames';
import { TbodyViewProps } from './Tbody/Tbody.view';

export type TableViewProps = {
  //
  children: ReactElement<TbodyViewProps>;
  tableStyle:
    | 'basic'
    | 'hover'
    | 'stripes'
    | 'scrolling'
    | 'hover_stripes'
    | 'hover_scrolling'
    | 'stripes_scrolling'
    | 'stacked_scrolling'
    | 'hover_stripes_scrolling';
  stackBreakpoint?: 'small' | 'medium' | 'tablet-portrait' | 'large' | 'xlarge' | 'xxlarge';
};

export const TableView = (props: TableViewProps): JSX.Element => {
  const stylesArr: string[] = props.tableStyle.split('_').map((style: string) => {
    switch (style) {
      case 'stripes':
        return 'striped';
      case 'scrolling':
        return 'table-scroll';
      default:
        return style;
    }
  });

  const findScroll = stylesArr.indexOf('table-scroll');
  if (findScroll > -1) {
    stylesArr.splice(findScroll, 1);
  }
  const tableClasses = classNames(...stylesArr);

  const globalClasses = classNames(classes.Table, {
    [classes.TableScroll]: findScroll > -1
  });

  return (
    <div className={globalClasses}>
      <table className={tableClasses}>{props.children}</table>
    </div>
  );
};
